import { lazy } from 'react';

const ArchiveInvoices = lazy(() => import('./ArchiveInvoices'));

export default ArchiveInvoices;
